import React from 'react';
import { Zoom } from 'react-toastify';
import NotificationStyled from './styles/NotificationStyled';

const Notification = () => {
  return (
    <NotificationStyled
      transition={Zoom}
      limit={3}
      position="bottom-right"
      draggable
      pauseOnHover
      hideProgressBar
      autoClose={5000}
    />
  );
};

export default Notification;
